import { Component, output, viewChild } from '@angular/core';
import { UiButtonComponent, UIIconComponent } from '@design-system';
import { BottomSheetComponent } from '../../../../components/bottom-sheet/bottom-sheet.component';

/**
 * The portfolio's three-dot menu, opened from the header.
 *
 * A menu rather than a direct jump into the settings because the handoff reaches
 * تنظیمات پرتفوی through it — "منوی سه‌نقطه پرتفوی ← تنظیمات پرتفوی ← انتخاب مبنای
 * قیمت" — and the same sheet is where the portfolio's other menu entries land as
 * they arrive. It owns none of them: each row emits, and the screen decides what
 * opening it means.
 */
@Component({
	selector: 'app-portfolio-menu-bottom-sheet',
	imports: [BottomSheetComponent, UiButtonComponent, UIIconComponent],
	templateUrl: './portfolio-menu-bottom-sheet.component.html',
	host: {
		'data-cy': 'portfolio-menu-bottom-sheet'
	}
})
export class PortfolioMenuBottomSheetComponent {
	/** تنظیمات پرتفوی was chosen. */
	readonly settingsSelected = output<void>();
	/** بیانیه ریسک was chosen. */
	readonly riskStatementSelected = output<void>();

	private readonly sheet = viewChild<BottomSheetComponent>('sheet');

	open(): Promise<void> {
		return this.sheet()?.open() ?? Promise.resolve();
	}

	close(): Promise<void> {
		return this.sheet()?.close() ?? Promise.resolve();
	}

	/**
	 * Closes before emitting: the sheet the row opens queues behind this one
	 * either way (`BottomSheetComponent` presents sheets FIFO), and closing first
	 * is what makes the trader see one sheet replaced by another rather than two
	 * opening.
	 */
	async onSettingsClick(): Promise<void> {
		await this.close();
		this.settingsSelected.emit();
	}

	/** Same handoff as the row above; only the sheet on the other side differs. */
	async onRiskStatementClick(): Promise<void> {
		await this.close();
		this.riskStatementSelected.emit();
	}
}
